import React, { useState } from "react";
import "./fold.css";

const Fold9 = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: "Higher Conversions",
      answer: "Turn passive abandoners into paying customers.",
    },
    {
      question: "Instant Support",
      answer: "Answer questions that email can't.",
    },
    {
      question: "Improve AOV",
      answer: "Suggest upsells during calls → more revenue.",
    },
    {
      question: "24/7 Automation",
      answer: "Consistent recovery without hiring extra staff.",
    },
    {
      question: "Smarter Marketing",
      answer: "Data on why customers bail helps optimize store experience.",
    },
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="fold-content-three">
      <div className="faq-container-three">
        <div className="faq-two-column-three">
          <div className="faq-header-column-three">
            <div className="section-header-three">
              <h2 className="section-title-three">Benefits</h2>
              <p className="section-subtitle-three">Why It Works</p>
            </div>
          </div>

          <div className="faq-content-column-three">
            <div className="faq-list-three">
              {faqs.map((faq, index) => (
                <div
                  key={index}
                  className={`faq-item-three ${
                    openIndex === index ? "active-three" : ""
                  }`}
                  style={{ animationDelay: `${index * 0.1}s` }}
                >
                  <button
                    className="faq-question-three"
                    onClick={() => toggleFAQ(index)}
                    aria-expanded={openIndex === index}
                  >
                    <span className="question-text-three">{faq.question}</span>
                    <span
                      className={`faq-icon-three ${
                        openIndex === index ? "open-three" : ""
                      }`}
                    >
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                      >
                        <path d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z" />
                      </svg>
                    </span>
                  </button>
                  <div
                    className={`faq-answer-three ${
                      openIndex === index ? "open-three" : ""
                    }`}
                  >
                    <div className="answer-content-three">
                      <p>{faq.answer}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Fold9;
